import { useTranslation } from "next-i18next";
import { motion } from "framer-motion";
import { useState, useEffect, useMemo } from "react";
import Image from "next/image";
interface HeaderProps {
  pageSubHeader?: string;
  pageHeader: string;
  backgroundImage?: string;
  backgroundVideo?: string;
}
const AnimatedRoundedPageHeader: React.FC<HeaderProps> = ({
  pageSubHeader = "text-page-explore",
  pageHeader = "text-page-header",
  backgroundImage,
  backgroundVideo
}) => {
  const {
    t
  } = useTranslation("common");
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(true);
  }, []);
  const containerVariants = {
    hidden: {
      clipPath: "inset(10% 10% 10% 10% round 20px)",
      opacity: 0
    },
    visible: {
      clipPath: "inset(0% 0% 0% 0% round 20px)",
      opacity: 1,
      transition: {
        duration: 1,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const videoSrc = useMemo(() => backgroundVideo || "/assets/images/video/aloe_bottles.mp4", [backgroundVideo]);
  return <motion.div className="relative h-64 md:h-80 lg:h-96 xl:h-112 2xl:h-128 overflow-hidden m-4 border border-transparent dark:border-neutral-800 rounded-3xl" variants={containerVariants} initial="hidden" animate={isVisible ? "visible" : "hidden"} data-sentry-element="unknown" data-sentry-component="AnimatedRoundedPageHeader" data-sentry-source-file="page-header.tsx">
      {backgroundImage ? <Image src={backgroundImage} alt="Page Header Background" layout="fill" objectFit="cover" quality={100} priority className="rounded-3xl" /> : backgroundVideo ? <video src={backgroundVideo} autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover rounded-3xl" /> : <video src={videoSrc} autoPlay muted loop playsInline preload="none" className="absolute inset-0 w-full h-full object-cover rounded-3xl" />}

      <div className="absolute inset-0 bg-black bg-opacity-50 transition-opacity duration-500 group-hover:bg-opacity-70 rounded-3xl" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center">
          <motion.span variants={itemVariants} className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-regular text-white" data-sentry-element="unknown" data-sentry-source-file="page-header.tsx">
            {t(`${pageHeader}`)}
          </motion.span>
          <motion.h2 variants={itemVariants} className="font-satisfy text-xl md:text-2xl text-white mt-3 block" data-sentry-element="unknown" data-sentry-source-file="page-header.tsx">
            {t(`${pageSubHeader}`)}
          </motion.h2>
        </div>
      </div>
    </motion.div>;
};
export default AnimatedRoundedPageHeader;